// Easter egg — code Konami → révèle un overlay 6 s. Extrait de app/page.tsx.
import { useEffect, useState } from 'react'

const KONAMI = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a']

export function useKonami() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const seq: string[] = []
    const handler = (e: KeyboardEvent) => {
      seq.push(e.key)
      if (seq.length > KONAMI.length) seq.shift()
      if (seq.join(',') === KONAMI.join(',')) {
        setVisible(true)
        setTimeout(() => setVisible(false), 6000)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])

  return visible
}
